import { Component, Inject, forwardRef } from '@angular/core';

import { AwesomeDataTable } from './../table/table.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'adata-table-pagination',
  template: `<div class="pagination-box">
    <div class="clearfix">
        <span class="float-md-left text-gray page-number"
                [textContent]="adataTable.translations.paginationResult((adataTable.offset + 1), ([adataTable.offset + adataTable.limit , adataTable.itemCount] | min), (adataTable.itemCount))"></span>
        <nav class="float-md-right">
            <ul class="pagination">
                <li class="page-item disabled" [ngClass]="{'disabled':!btnPrevAvaialble}">
                    <button type="button" class="page-link" (click)="pageFirst(btnPrevAvaialble)"><span class="fa fa-angle-double-left"></span></button>
                </li>
                <li class="page-item disabled" [ngClass]="{'disabled':!btnPrevAvaialble}">
                    <button type="button" class="page-link" (click)="pageBack(btnPrevAvaialble)"><span class="fa fa-angle-left"></span></button>
                </li>
                <li class="page-item" *ngFor="let p of pages;" [ngClass]="{'active':page-1==p}">
                    <button type="button" class="page-link" (click)="pageNavigate(p)" [textContent]="p+1"></button>
                </li>
                <li class="page-item" [ngClass]="{'disabled':!btnNextAvaialble}">
                    <button type="button" class="page-link" (click)="pageForward(btnNextAvaialble)"><span class="fa fa-angle-right"></span></button>
                </li>
                <li class="page-item" [ngClass]="{'disabled':!btnNextAvaialble}">
                    <button type="button" class="page-link" (click)="pageLast(btnNextAvaialble)"><span class="fa fa-angle-double-right"></span></button>
                </li>
            </ul>
        </nav>
    </div>
</div>`,
  styles: [`.pagination-box{position:relative}.pagination-box .pagination{margin-bottom:16px;margin-right:16px}@media (max-width:768px){.pagination-box .pagination{margin:16px}}.pagination-box .page-number{margin:5px 0 0 16px}.pagination-box .text-gray{color:#607d8b}.pagination-box .page-item.disabled .page-link{background-color:rgba(160,160,160,.25);border-color:rgba(162,162,162,.5)}`]
})
// tslint:disable-next-line:component-class-suffix
export class AwesomeDataTablePagination {
    get maxPage() {
        return Math.ceil(this.adataTable.itemCount / this.adataTable.limit);
    }

    get pages() {
        return Array.from(Array(this.maxPage).keys());
    }

    get limit() {
        return this.adataTable.limit;
    }

    set limit(value) {
        this.adataTable.limit = Number(<any>value); // TODO better way to handle that value of number <input> is string?
    }

    get page() {
        return this.adataTable.page;
    }

    set page(value) {
        this.adataTable.page = Number(<any>value);
    }

    get btnNextAvaialble() {
        return !((this.adataTable.offset + this.adataTable.limit) >= this.adataTable.itemCount);
    }

    get btnPrevAvaialble() {
        return !(this.adataTable.offset <= 0);
    }

    constructor(@Inject(forwardRef(() => AwesomeDataTable)) public adataTable: AwesomeDataTable) {}

    pageBack(allow: boolean = true) {
        if (allow) {
            this.adataTable.offset -= Math.min(this.adataTable.limit, this.adataTable.offset);
        }
    }

    pageForward(allow: boolean = true) {
        if (allow) {
            this.adataTable.offset += this.adataTable.limit;
        }
    }

    pageFirst(allow: boolean = true) {
        if (allow) {
            this.adataTable.offset = 0;
        }
    }

    pageLast(allow: boolean = true) {
        if (allow) {
            this.adataTable.offset = (this.maxPage - 1) * this.adataTable.limit;
        }
    }

    pageNavigate(page) {
        const val = page * this.adataTable.limit;
        if (val !== this.adataTable.offset) {
            this.adataTable.offset = val;
        }
    }
}
